export enum RacingSportTypesEnum {
	Horse = 31,
	Greyhounds = 184,
}

export const RacingSportTypesIconsEnum = {
	[RacingSportTypesEnum.Horse]: "racing-horse",
	[RacingSportTypesEnum.Greyhounds]: "racing-greyhounds",
};
